import React from 'react';
import { TextField, Grid, Avatar, MenuItem, Select, Fab, Switch, Divider, } from '@material-ui/core';

import PropTypes from 'prop-types';
import Utils from '../providers/Utils';
import Ws from '../providers/Ws';
import Menu from './Menu';
import SpecificComponent from './SpecificComponent';
import CustomUserMenu from './CustomUserMenu';


export default class DocumenteTaskRows extends SpecificComponent {
    constructor(props) {
        super(props);

        this.docTask = React.createRef()
        this.state = {
            strSearchString: '',
            elementeAfisate: []

        }
    }



    componentDidMount() {
        console.warn('this.props.tipCost docRows :>> ', this.props.tipCost);
        console.warn('lista costuri', this.props.listaCosturi);
        this.setState({ elementeAfisate: this.props.elemente || [] })
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            elementeAfisate: nextProps.elemente || [],
        })
    }

    reMountChild = () => {
        console.log('docTask REMOUNT :>> ');
        this.docTask.current.userSelectat()
    }


    // filterFunc = (ev) => {

    //     this.setState({strSearchString:ev.target.value})
    //     let e = [...this.props.elemente]

    //     e = e.filter(x=>{

    //         if( (x[this.props.onlyColumns.nume]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
    //             return true

    //         if( (x[this.props.onlyColumns.description]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
    //             return true

    //         return false

    //     })

    //     this.setState({elementeAfisate: e})
    // }




    totalNet = (c) => {


        if (c.pret && c.cantitate) {

            if (Number(c.tva_inclus) === 1) {


                let total = ((c.pret * c.cantitate) - (c.pret * c.cantitate) * (c.tva) / (c.tva + 100))

                return +(Math.round(total + "e+3") + "e-3");
            } else {
                // return (c.pret * c.cantitate).toFixed(3)
                return +(Math.round((c.pret * c.cantitate) + "e+3") + "e-3");
            }

        } else {
            return ''
        }
    }


    totalTva = (c) => {

        if (c.pret && c.cantitate && c.tva) {

            if (Number(c.tva_inclus) === 1) {
                let total = ((c.pret * c.cantitate) * (c.tva) / (c.tva + 100))

                return +(Math.round(total + "e+3") + "e-3");

            } else {
                let total = (((c.pret * c.cantitate) * c.tva) / 100)

                return +(Math.round(total + "e+3") + "e-3");
            }

        } else {
            console.log('elseTotalTva :>> ');
            return ''
        }


    }

    totalTVAALL = () => {

        let tva = 0

        for (let i = 0, n = this.props.listaCosturi.length; i < n; i++) {
            console.log('this.props.listaCosturi :>> ', this.props.listaCosturi[i]);

            if (Number(this.props.listaCosturi[i].tva_inclus) === 1) {
                console.log('tva :>> ', ((this.props.listaCosturi[i].pret * this.props.listaCosturi[i].cantitate) * (this.props.listaCosturi[i].tva) / (this.props.listaCosturi[i].tva + 100)));

                tva += ((this.props.listaCosturi[i].pret * this.props.listaCosturi[i].cantitate) * (this.props.listaCosturi[i].tva) / (this.props.listaCosturi[i].tva + 100))


            } else {

                console.log('tva2 :>> ', (((this.props.listaCosturi[i].pret * this.props.listaCosturi[i].cantitate) * this.props.listaCosturi[i].tva) / 100));
                tva += (((this.props.listaCosturi[i].pret * this.props.listaCosturi[i].cantitate) * this.props.listaCosturi[i].tva) / 100)
            }



        }


        return +(Math.round(tva + "e+3") + "e-3");

        // return tva.toFixed(3)

    }

    totalAll = () => {

        let sum = 0
        for (let i = 0, n = this.props.listaCosturi.length; i < n; i++) {

            if (Number(this.props.listaCosturi[i].tva_inclus) === 1) {
                sum += (this.props.listaCosturi[i].pret * this.props.listaCosturi[i].cantitate)
            } else {

                sum += ((this.props.listaCosturi[i].pret * this.props.listaCosturi[i].cantitate) * this.props.listaCosturi[i].tva) / 100 + (this.props.listaCosturi[i].pret * this.props.listaCosturi[i].cantitate)
            }
        }
        return +(Math.round(sum + "e+3") + "e-3");

        // return sum.toFixed(3)
    }

    total = (c) => {



        if (c.pret && c.cantitate && c.tva) {
            if (Number(c.tva_inclus) === 1) {


                let total = ((c.pret * c.cantitate))
                return +(Math.round(total + "e+3") + "e-3");

            } else {


                let total = ((((c.pret * c.cantitate) * c.tva) / 100) + (c.pret * c.cantitate))

                return +(Math.round(total + "e+3") + "e-3");

            }
        } else {
            return ''
        }

    }


    addBackgroundColor = (c) => {
        if (c.pret && c.cantitate && c.tva && c.denumire) {
            return 'rgb(24, 166, 59)'
        } else {
            return 'transparent'
        }
    }


    addColor = (c) => {
        if (c.pret && c.cantitate && c.tva && c.denumire) {
            return 'white'
        } else {
            return 'black'
        }
    }



    changeTvaInclus = (ev, c) => {



    }


    render() {
        return (

            <div>

                {this.props.tipCost === 'cost_direct' &&
                    <table className='cheltuieli-rows' style={{ textAlign: 'left', fontSize: 14, marginTop: 40, tableLayout: 'auto' }}>

                        <thead>
                            {this.props.listaCosturi.length > 0 &&
                                <tr>
                                    <th style={{ width: '20%' }}>{this.dictionary.proiecte.denumire}</th>
                                    <th>{this.dictionary.proiecte.quantity}</th>
                                    <th>{this.dictionary.proiecte.price}</th>
                                    <th>{this.dictionary.proiecte.tvaIncl}</th>
                                    <th style={{ width: '7%' }}>{this.dictionary.proiecte.tva}%</th>
                                    <th>{this.dictionary.proiecte.total}</th>
                                    <th>{this.dictionary.proiecte.valTva}</th>
                                    <th>{this.dictionary.proiecte.total}+{this.dictionary.proiecte.tva}</th>
                                    {this.props.cost &&

                                        <th>Buget</th>
                                    }
                                    <th>Operatiuni</th>


                                </tr>
                            }

                        </thead>
                        <tbody>
                            {this.props.listaCosturi.map((c, idx) => {
                                return (
                                    <tr key={idx}>
                                        <td style={{ paddingTop: 5 }}>
                                            <div style={{ position: 'relative' }}>
                                                <input
                                                    style={{ fontSize: 14, fontWeight: 400, width: '95%' }}
                                                    id='titlu-task'
                                                    type="text"
                                                    className='add-project-input'
                                                    margin="normal"
                                                    name='denumire'
                                                    value={c.denumire || ''}
                                                    onChange={(ev) => { this.props.changeObj(ev, c) }}
                                                    onBlur={() => { this.props.updateCost(c) }}
                                                />
                                                <label className='inputLabelPM' htmlFor='titlu-task'>{this.dictionary.proiecte.denumireProdus}</label>
                                            </div>

                                        </td>
                                        <td style={{ paddingTop: 5 }}>
                                            <div style={{ position: 'relative' }}>
                                                <input
                                                    style={{ fontSize: 14, fontWeight: 400, width: '90%' }}
                                                    id='cantitate'
                                                    type="number"
                                                    step='any'
                                                    min='0'

                                                    className='add-project-input'
                                                    margin="normal"
                                                    name='cantitate'
                                                    value={c.cantitate || ''}
                                                    onChange={(ev) => { this.props.changeObj(ev, c) }}
                                                    onBlur={() => { this.props.updateCost(c) }}
                                                />
                                                <label className='inputLabelPM' htmlFor='cantitate'>{this.dictionary.proiecte.quantity}</label>
                                            </div>
                                        </td>
                                        <td style={{ paddingTop: 5 }}>
                                            <div style={{ position: 'relative' }}>
                                                <input
                                                    style={{ fontSize: 14, fontWeight: 400, width: '90%' }}
                                                    id='pret'
                                                    type="number"
                                                    step='any'
                                                    min='0'

                                                    className='add-project-input'
                                                    margin="normal"
                                                    name='pret'
                                                    value={c.pret || ''}
                                                    onChange={(ev) => { this.props.changeObj(ev, c) }}
                                                    onBlur={() => { this.props.updateCost(c) }}
                                                />
                                                <label className='inputLabelPM' htmlFor='pret'>{this.dictionary.proiecte.price}</label>
                                            </div>
                                        </td>
                                        <td style={{ paddingTop: 5 }}>
                                            <div style={{ position: 'relative' }}>
                                                <select
                                                    id='tipTva'
                                                    style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                    className='add-project-input'
                                                    type="text"
                                                    margin="normal"
                                                    name='tva_inclus'
                                                    value={c.tva_inclus || 0}
                                                    onChange={(ev) => { this.props.changeObj(ev, c) }}
                                                    // placeholder='Selecteaza Tipul'
                                                    onBlur={() => { this.props.updateCost(c) }}
                                                >


                                                    {this.props.tipuriTVA.map((l, idx) => {
                                                        return (
                                                            <option key={idx} value={l.id}>{l.nume}</option>
                                                        )
                                                    })}
                                                </select>
                                                <label className='inputLabelPM' htmlFor='tipTva'>{this.dictionary.proiecte.tvaIncl}</label>
                                            </div>
                                        </td>
                                        <td style={{ paddingTop: 5 }}>
                                            <div style={{ position: 'relative' }}>
                                                <select
                                                    id='TVA'
                                                    style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                    className='add-project-input'
                                                    type="text"
                                                    margin="normal"
                                                    name='tva'
                                                    value={c.tva || 19}
                                                    onChange={(ev) => { this.props.changeObj(ev, c) }}
                                                    // placeholder='Selecteaza Tipul'
                                                    onBlur={() => { this.props.updateCost(c) }}
                                                >


                                                    {this.props.valoriTva.map((l, idx) => {
                                                        return (
                                                            <option key={idx} value={l}>{l}</option>
                                                        )
                                                    })}
                                                </select>
                                                <label className='inputLabelPM' htmlFor='TVA'>{this.dictionary.proiecte.tva}%</label>
                                            </div>
                                        </td>
                                        <td style={{ paddingTop: 5 }}>

                                            <div style={{ position: 'relative' }}>
                                                <input
                                                    style={{ fontSize: 14, fontWeight: 400, width: '90%' }}
                                                    id='totalNet'
                                                    type="number"
                                                    className='add-project-input'
                                                    margin="normal"
                                                    name='pret'
                                                    value={this.totalNet(c)}
                                                    disabled={true}
                                                />
                                                <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.proiecte.value}</label>


                                            </div>

                                        </td>

                                        <td style={{ paddingTop: 5 }}>

                                            <div style={{ position: 'relative' }}>
                                                <input
                                                    style={{ fontSize: 14, fontWeight: 400, width: '90%' }}
                                                    id='totalTVA'
                                                    type="number"
                                                    className='add-project-input'
                                                    margin="normal"
                                                    name='pret'
                                                    value={this.totalTva(c)}
                                                    disabled={true}
                                                />
                                                <label className='inputLabelPM' htmlFor='totalTVA'>{this.dictionary.proiecte.valTva}</label>


                                            </div>

                                        </td>
                                        <td style={{ paddingTop: 5 }}>
                                            <div style={{ position: 'relative' }}>
                                                <input
                                                    style={{ fontSize: 14, fontWeight: 400, width: '90%' }}
                                                    id='valoareTotala'
                                                    type="number"
                                                    className='add-project-input'
                                                    margin="normal"
                                                    name='pret'
                                                    value={this.total(c)}
                                                    disabled={true}
                                                />
                                                <label className='inputLabelPM' htmlFor='valoareTotala'>{this.dictionary.proiecte.sum}+{this.dictionary.proiecte.tva}</label>


                                            </div>

                                        </td>
                                        {this.props.cost &&
                                            <td style={{ paddingTop: 5, width: '14%' }}>
                                                <div style={{ position: 'relative' }}>
                                                    <select
                                                        id='tipBuget'
                                                        style={{ width: '100%', paddingTop: 9, paddingBottom: 9 }}
                                                        className='add-project-input'
                                                        type="text"
                                                        margin="normal"
                                                        name='id_buget'
                                                        value={c.id_buget || '0'}
                                                        onChange={(ev) => { this.props.changeObj(ev, c) }}
                                                        // placeholder='Selecteaza Tipul'
                                                        onBlur={() => { this.props.alocaBuget(c) }}
                                                    >
                                                        <option value={'0'}>{this.dictionary.proiecte.alocaBuget}</option>

                                                        {this.props.bugete.map((l, idx) => {
                                                            return (
                                                                <option key={idx} value={l.id}>{l.nume}</option>
                                                            )
                                                        })}
                                                    </select>
                                                    <label className='inputLabelPM' htmlFor='tipBuget'>{this.dictionary.proiecte.bugetAlocat}</label>
                                                </div>

                                            </td>
                                        }

                                        <td>
                                            <input type='file' id={`fileCost1${c.id}`}
                                                style={{ display: 'none' }}
                                                accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                                                onChange={() => { this.props.uploadCostDoc(`fileCost1${c.id}`, c) }} />
                                            <i onClick={() => { this.props.openFile(`fileCost1${c.id}`) }} style={{ marginRight: 10, cursor: 'pointer' }} className='material-icons pm-standard-icons'>attachment</i>
                                            <i style={{ cursor: 'pointer' }} onClick={() => { this.props.deleteCost(c) }} className='material-icons pm-standard-icons'>delete</i>
                                        </td>

                                    </tr>
                                )
                            })}
                            <tr>
                                <td colSpan={10}> </td>

                            </tr>
                            <tr style={{ marginTop: 20 }}>
                                <td>
                                    {this.props.tipIntroducere === 'defalcata' &&
                                        <span onClick={this.props.addCost} id='cheltuieli-label' className='insert-task-labels'> <span style={{
                                            fontSize: 14,
                                            fontWeight: 400,
                                            color: '#579ae8'
                                        }}>{this.dictionary.proiecte.addNewProduct}
                                            <div

                                                className={'cheltuieli-label-icons'}
                                            >

                                                <i
                                                    style={{ fontSize: 20, verticalAlign: 'sub', color: 'black', marginLeft: 10 }}
                                                    className='material-icons pm-standard-icons'>add</i>


                                            </div>
                                        </span>
                                        </span>
                                    }

                                </td>
                                <td colSpan={5}></td>
                                <td>{this.dictionary.proiecte.total} {this.dictionary.proiecte.tva}</td>
                                <td>{this.dictionary.proiecte.total}+{this.dictionary.proiecte.tva}</td>
                                <td colSpan={this.props.cost ? 2 : 1}></td>
                            </tr>
                            <tr>
                                <td colSpan={6}></td>
                                <td style={{ fontWeight: 700 }}>{this.totalTVAALL()}</td>
                                <td style={{ fontWeight: 700 }}>{this.totalAll()}</td>
                                <td colSpan={this.props.cost ? 2 : 1}></td>
                            </tr>

                            {/* <tr >
                        <td>
                            <input
                                style={{ fontSize: 14, fontWeight: 400, width: '80%' }}
                                id='titlu-task'
                                type="text"
                                className='hidden-input'
                                margin="normal"
                                name='denumire'
                                value={this.props.costToAdd.denumire || ''}
                                onChange={this.props.changeObjToAdd}
                            />
                        </td>
                        <td>
                            <input
                                style={{ fontSize: 14, fontWeight: 400, width: '50%' }}
                                id='titlu-task'
                                type="number"
                                className='hidden-input'
                                margin="normal"
                                name='cantitate'
                                value={this.props.costToAdd.cantitate || ''}
                                onChange={this.props.changeObjToAdd}
                            />
                        </td>
                        <td>
                            <input
                                style={{ fontSize: 14, fontWeight: 400, width: '50%' }}
                                id='titlu-task'
                                type="number"
                                className='hidden-input'
                                margin="normal"
                                name='pret'
                                value={this.props.costToAdd.pret || ''}
                                onChange={this.props.changeObjToAdd}
                            />
                        </td>
                        <td>
                            <input
                                style={{ fontSize: 14, fontWeight: 400, width: '50%' }}
                                id='titlu-task'
                                type="number"
                                className='hidden-input'
                                margin="normal"
                                name='tva'
                                value={this.props.costToAdd.tva || ''}
                                onChange={this.props.changeObjToAdd}
                            />
                        </td>
                        <td>{this.totalNet(this.props.costToAdd)}</td>
                        <td>{this.totalTva(this.props.costToAdd)}</td>
                        <td>{this.total(this.props.costToAdd)}</td>
                        <td style={{ cursor: 'pointer' }} onClick={this.props.addCost}><i
                            style={{ backgroundColor: this.addBackgroundColor(this.props.costToAdd), color: this.addColor(this.props.costToAdd), borderRadius: 20, padding: 5 }}
                            className='material-icons'>check_circle_outline</i></td>

                    </tr> */}
                        </tbody>

                    </table>

                }

                {this.props.tipCost === 'cost_personal' &&
                    <table className='cheltuieli-rows' style={{ textAlign: 'left', fontSize: 14, marginTop: 40 }}>

                        <thead>
                            {this.props.listaCosturi.length > 0 &&
                                <tr>
                                    <th style={{ width: '30%' }}>{this.dictionary.proiecte.worker}</th>
                                    <th style={{ width: '15%' }}>{this.dictionary.proiecte.hours}</th>
                                    <th style={{ width: '15%' }}>{this.dictionary.proiecte.price}/{this.dictionary.proiecte.hour}</th>
                                    <th style={{ width: '15%' }}>{this.dictionary.proiecte.total}</th>


                                    <th style={{ width: '15%' }}>{this.props.cost && 'Buget'}</th>


                                    <th style={{ width: '10%' }}>{this.dictionary.proiecte.operations}</th>


                                </tr>
                            }

                        </thead>
                        {/* <tbody>
                          
                            <tr>
                                <td colSpan={10}> </td>

                            </tr>
                            <tr style={{ marginTop: 20 }}>
                                <td>
                                    {this.props.tipIntroducere === 'defalcata' &&
                                        <span onClick={this.props.addCost} id='cheltuieli-label' className='insert-task-labels'> <span style={{
                                            fontSize: 14,
                                            fontWeight: 400,
                                            color: '#579ae8'
                                        }}>Adauga Lucrator Nou
                                                <div

                                                className={'cheltuieli-label-icons'}
                                            >

                                                <i
                                                    style={{ fontSize: 20, verticalAlign: 'sub', color: 'black', marginLeft: 10 }}
                                                    className='material-icons pm-standard-icons'>add</i>


                                            </div>
                                        </span>
                                        </span>
                                    }

                                </td>
                                <td colSpan={4}></td>



                            </tr>




                        </tbody> */}

                    </table>
                }


                {this.props.tipCost === 'cost_personal' && this.props.listaCosturi.map((c, idx) => {
                    return (

                        <DocumenteLiRows
                            key={idx}
                            uploadCostDoc={this.props.uploadCostDoc}
                            openFile={this.props.openFile}
                            deleteCost={this.props.deleteCost}
                            updateCost={this.props.updateCost}
                            changeObj={this.props.changeObj}
                            changeUserCost={this.props.changeUserCost}
                            listUsers={this.props.listUsers}
                            idx={idx}
                            ref={this.docTask}
                            totalNet={this.totalNet}
                            addCost={this.props.addCost}
                            cost={this.props.cost}
                            bugete={this.props.bugete}
                            alocaBuget={this.props.alocaBuget}
                            c={c} />

                    )
                })}

                {this.props.tipCost === 'cost_personal' &&
                    <Grid container>
                        <Grid style={{ marginTop: 20, marginBottom: 20 }} item>

                            <span onClick={this.props.addCost} id='cheltuieli-label' className='insert-task-labels'> <span style={{
                                fontSize: 14,
                                fontWeight: 400,
                                color: '#579ae8'
                            }}>{this.dictionary.proiecte.addNewWorker}
                                <div

                                    className={'cheltuieli-label-icons'}
                                >

                                    <i
                                        style={{ fontSize: 20, verticalAlign: 'sub', color: 'black', marginLeft: 10 }}
                                        className='material-icons pm-standard-icons'>add</i>


                                </div>
                            </span>
                            </span>


                        </Grid>
                    </Grid>
                }


            </div>

        )
    }
}





class DocumenteLiRows extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            isOpenUtilizator: false,
            userLinie: { id: 0, nume: null, poza: null, cost_minut: 0 }

        }
    }

    componentDidMount() {
        this.userSelectat()
    }

    componentDidUpdate(prevProps) {

        console.log('prevProps :>> ', prevProps.c);
        console.log('this.props.c :>> ', this.props.c);


        if (this.props.c.denumire !== prevProps.c.denumire) {
            this.userSelectat()
        }



        // if (this.props.userID !== prevProps.userID) {
        //     this.fetchData(this.props.userID);
        //   }
    }

    userSelectat = () => {

        if (this.props.c.denumire.length > 0) {
            let useri = [...this.props.listUsers]

            let userLinie = { ...userLinie }

            console.log('useri :>> ', useri);

            console.log('this.props.c :>> ', this.props.c);

            let idx = useri.findIndex(u => Number(u.id) === Number(this.props.c.denumire))

            console.log('idx :>> ', idx);
            if (idx !== -1) {
                userLinie['nume'] = useri[idx]['nume']
                userLinie['cost_minut'] = useri[idx]['cost_minut']
                userLinie['id'] = useri[idx]['id']

                this.setState({ userLinie: userLinie })
            }

            console.log('userLinie :>> ', userLinie);
        }


    }

    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }

    openUserMenu = () => {
        this.setState({
            isOpenUtilizator: true
        })
    }

    closeUtilizator = async (u) => {

      

        if (u) {
            console.log('u :>> ', u);
            this.setState({ isOpenUtilizator: false }, () => {
                this.props.changeUserCost(u, this.props.c)

            })
        }

    }


    render() {
        return (
            // <div></div>
            <Grid container key={this.props.idx} style={{ marginTop: 20 }}>

                <Grid item style={{ width: '30%' }}>
                    <div style={{ width: 'fit-content', height: '100%', position: 'relative', cursor: 'pointer', display: 'inline-block' }}>


                        <div style={{ display: 'inline-block', width: '100%' }}>
                            <CustomUserMenu
                                user={this.state.userLinie}
                                clearInput={() => {


                                    this.props.clearAngajat()
                                }}
                                openList={() => { this.setState({ isOpenUtilizator: this.state.isOpenUtilizator ? false : true }) }}
                                closeList={this.closeUtilizator}
                                showList={this.state.isOpenUtilizator}
                                users={this.props.listUsers}
                                selectUser={this.closeUtilizator}
                                width={'100%'}
                                label={this.dictionary.proiecte.selectUser}

                            />
                        </div>

                    </div>

                </Grid>
                <Grid item style={{ width: '15%' }}>
                    <div style={{ position: 'relative' }}>
                        <input
                            style={{ fontSize: 14, fontWeight: 400, width: '90%' }}
                            id='cantitate'
                            type="text"
                            className='add-project-input'
                            margin="normal"
                            name='cantitate'
                            value={this.props.c.cantitate || ''}
                            onChange={(ev) => { this.props.changeObj(ev, this.props.c) }}
                            onBlur={() => { this.props.updateCost(this.props.c) }}
                        />
                        <label className='inputLabelPM' htmlFor='cantitate'>{this.dictionary.proiecte.hours}</label>
                    </div>
                </Grid>

                <Grid item style={{ width: '15%' }}>
                    <div style={{ position: 'relative' }}>
                        <input
                            style={{ fontSize: 14, fontWeight: 400, width: '90%' }}
                            id='cantitate'
                            type="text"
                            className='add-project-input'
                            margin="normal"
                            name='cantitate'
                            value={this.props.c.pret || '0'}
                            disabled={true}
                        // onChange={(ev) => { this.props.changeObj(ev, this.props.c) }}
                        // onBlur={() => { this.props.updateCost(this.props.c) }}
                        />
                        <label className='inputLabelPM' htmlFor='cantitate'>{this.dictionary.proiecte.price}/{this.dictionary.proiecte.hour}</label>
                    </div>
                </Grid>

                <Grid item style={{ width: '15%' }}>
                    <div style={{ position: 'relative' }}>
                        <input
                            style={{ fontSize: 14, fontWeight: 400, width: '90%' }}
                            id='cantitate'
                            type="text"
                            className='add-project-input'
                            margin="normal"
                            name='cantitate'
                            value={this.props.totalNet(this.props.c) || '0'}
                            disabled={true}
                        // onChange={(ev) => { this.props.changeObj(ev, this.props.c) }}
                        // onBlur={() => { this.props.updateCost(this.props.c) }}
                        />
                        <label className='inputLabelPM' htmlFor='cantitate'>{this.dictionary.proiecte.total}</label>
                    </div>
                </Grid>
                {this.props.cost &&
                    <Grid item style={{ width: '15%' }}>
                        <div style={{ position: 'relative' }}>
                            <select
                                id='tipBuget'
                                style={{ width: '100%', paddingTop: 9, paddingBottom: 9 }}
                                className='add-project-input'
                                type="text"
                                margin="normal"
                                name='id_buget'
                                value={this.props.c.id_buget || '0'}
                                onChange={(ev) => { this.props.changeObj(ev, this.props.c) }}
                                // placeholder='Selecteaza Tipul'
                                onBlur={() => { this.props.alocaBuget(this.props.c) }}
                            >
                                <option value={'0'}>{this.dictionary.proiecte.alocaBuget}</option>

                                {this.props.bugete.map((l, idx) => {
                                    return (
                                        <option key={idx} value={l.id}>{l.nume}</option>
                                    )
                                })}
                            </select>
                            <label className='inputLabelPM' htmlFor='tipBuget'>{this.dictionary.proiecte.bugetAlocat}</label>
                        </div>
                    </Grid>

                }


                {!this.props.cost &&
                    <Grid item style={{ width: '15%' }}>
                    </Grid>
                }




                <Grid item style={{ width: '10%' }}>
                    <input type='file' id={`fileCost1${this.props.c.id}`}
                        style={{ display: 'none' }}
                        accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                        onChange={() => { this.props.uploadCostDoc(`fileCost1${this.props.c.id}`, this.props.c) }} />
                    <i onClick={() => { this.props.openFile(`fileCost1${this.props.c.id}`) }} style={{ marginRight: 10, cursor: 'pointer' }} className='material-icons pm-standard-icons'>attachment</i>
                    <i style={{ cursor: 'pointer' }} onClick={() => { this.props.deleteCost(this.props.c) }} className='material-icons pm-standard-icons'>delete</i>

                </Grid>



            </Grid>
        )
    }
}